import { useMemo } from 'react'
import { PrintedDocumentLayout } from '../../pages/Printing/PrintedDocumentLayout'
import { convertFullCompanyToApi } from '../../services/ApiContext'
import { useCompanyStore } from '../../store/company/companyStore'
import { useFFEStore } from '../../store/ffeStore'

export const PreviewStructure = () => {
  const document = useFFEStore((state) => state.document)
  const company = useCompanyStore((state) => state.company)
  const suppliers = useFFEStore((state) => state.suppliers)
  const organisation = useMemo(
    () => convertFullCompanyToApi(company),
    [company]
  )
  const specification = useMemo(() => {
    const newDoc = { ...document }
    // replace all supplier fields on line items and materials with supplier names
    newDoc.lineItems = newDoc.lineItems.map((li) => {
      const supplier = suppliers.find((s) => s._id === li.supplier)
      return {
        ...li,
        supplier: supplier?.name
      }
    })
    newDoc.materials = newDoc.materials.map((m) => {
      const supplier = suppliers.find((s) => s._id === m.supplier)
      return {
        ...m,
        supplier: supplier?.name
      }
    })
    return newDoc
  }, [document, suppliers])
  return (
    <div className="border rounded-lg">
      <PrintedDocumentLayout
        specification={specification}
        organisation={organisation}
      />
    </div>
  )
}
